<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>外管绩效</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col :span="6">
            <Form-item label="开始日期">
              <Date-picker
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="startDate"
                placeholder="选择开始日期"
                @on-change="onStartDateChange">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="结束日期">
              <Date-picker
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="endDate"
                placeholder="选择结束日期"
                @on-change="onEndDateChange">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="外教运营">
              <Select v-model.number="queryParam.studyAdviserId" placeholder="全部"
                      clearable>
                <Option v-for="item in studyAdviserList"
                        :value="item.id" :key="item.id">{{ item.nickname }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item>
              <Button type="primary" :loading="searchLoading" @click="search">查询</Button>
              <Button type="primary" :loading="exportLoading" @click="exportData" style="margin-left: 10px">导出</Button>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>

    <div class="table-container">
      <Table
        :columns="columns"
        :data="tableData"
        :loading="tableLoading"
        border
        stripe>
      </Table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TchPerformanceList',
  data () {
    return {
      searchLoading: false,
      exportLoading: false,
      tableLoading: false,
      queryParam: {
        startDate: '',
        endDate: '',
        studyAdviserId: ''
      },
      startDate: '', // 日期选择器绑定的值
      endDate: '',   // 日期选择器绑定的值
      studyAdviserList: [],
      columns: [
        {
          title: '老师类型',
          key: 'teacherType',
          align: 'center',
          width: 120,
          fixed: 'left'
        },
        {
          title: '老师数量',
          key: 'teacherCount',
          align: 'center',
          width: 100
        },
        {
          title: '买断课时数',
          key: 'buyOutLessonCount',
          align: 'center',
          width: 120
        },
        {
          title: '上课数',
          key: 'lessonCount',
          align: 'center',
          width: 100
        },
        {
          title: '上课率',
          key: 'attendanceRate',
          align: 'center',
          width: 100
        },
        {
          title: '第四周上课率',
          key: 'fourthWeekAttendanceRate',
          align: 'center',
          width: 130
        },
        {
          title: '请假数',
          key: 'leaveCount',
          align: 'center',
          width: 100
        },
        {
          title: '外教请假率',
          key: 'foreignTeacherLeaveRate',
          align: 'center',
          width: 120
        },
        {
          title: '临时正常上课数',
          key: 'temporaryNormalLessonCount',
          align: 'center',
          width: 140
        },
        {
          title: '临时请假数',
          key: 'temporaryLeaveCount',
          align: 'center',
          width: 120
        },
        {
          title: '临时请假率',
          key: 'temporaryLeaveRate',
          align: 'center',
          width: 120
        },
        {
          title: '返课时',
          key: 'returnLessonHours',
          align: 'center',
          width: 100
        },
        {
          title: 'CPE+回访',
          key: 'cpeAndFollowUp',
          align: 'center',
          width: 120
        },
        {
          title: '外教离职',
          key: 'foreignTeacherResigned',
          align: 'center',
          width: 100
        },
        {
          title: '培训中外教数',
          key: 'trainingForeignTeachers',
          align: 'center',
          width: 140
        }
      ],
      tableData: []
    }
  },
  mounted () {
    // 获取外教运营列表
    this.getStudyAdviserList()
    // 设置默认日期为上周六到本周五
    this.initDefaultDate()
    // 初始化加载数据
    this.search()
  },
  methods: {
    // 获取外教运营列表
    getStudyAdviserList () {
      let self = this
      self.$http.post('/adminUser/listByCondition', {adminGroupId: 7, status: 1}).then(function (res) {
        if (!res || !res.data) {
          return
        }
        self.studyAdviserList = res.data
      })
    },
    // 计算并设置默认日期为上周六到本周五
    initDefaultDate () {
      const now = this.$moment()
      const currentDay = now.day() // 0 表示周日，1-6 表示周一到周六
      
      // 计算本周五：如果今天是周五或之后，则是本周五；否则是上周五
      let friday = now.clone()
      if (currentDay === 0) {
        // 今天是周日，本周五是 5 天前
        friday = now.clone().subtract(2, 'days')
      } else if (currentDay >= 6) {
        // 今天是周六，本周五是昨天
        friday = now.clone().subtract(1, 'days')
      } else {
        // 今天是周一到周四，本周五是 (5 - currentDay) 天后
        friday = now.clone().add(5 - currentDay, 'days')
      }
      
      // 计算上周六：本周五往前推 6 天
      const lastSaturday = friday.clone().subtract(6, 'days')
      
      // 格式化日期
      const startDate = lastSaturday.format('YYYY-MM-DD')
      const endDate = friday.format('YYYY-MM-DD')
      
      // 设置到 queryParam 和 v-model
      this.queryParam.startDate = startDate
      this.queryParam.endDate = endDate
      this.startDate = startDate
      this.endDate = endDate
    },
    onStartDateChange (value) {
      // 将日期转换为 yyyy-MM-dd 格式
      if (value) {
        this.queryParam.startDate = this.$moment(value).format('YYYY-MM-DD')
      } else {
        this.queryParam.startDate = ''
      }
    },
    onEndDateChange (value) {
      // 将日期转换为 yyyy-MM-dd 格式
      if (value) {
        this.queryParam.endDate = this.$moment(value).format('YYYY-MM-DD')
      } else {
        this.queryParam.endDate = ''
      }
    },
    search () {
      this.tableLoading = true
      this.searchLoading = true

      // 确保日期格式正确
      let params = {...this.queryParam}

      // 调用接口获取数据
      this.$http.post('/tch/statistics', params).
        then((res) => {
          if (res.data) {
            this.tableData = res.data
          } else {
            this.$Message.error(res.data.message || '获取数据失败')
          }
        }).
        catch((error) => {
          this.$Message.error('请求失败：' + error.message)
        }).
        finally(() => {
          this.tableLoading = false
          this.searchLoading = false
        })
    },
    exportData () {
      this.exportLoading = true

      // 确保日期格式正确
      let params = {...this.queryParam}
      if (params.startDate && !params.startDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
        params.startDate = this.$moment(params.startDate).format('YYYY-MM-DD')
      }
      if (params.endDate && !params.endDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
        params.endDate = this.$moment(params.endDate).format('YYYY-MM-DD')
      }

      // 导出逻辑
      this.$http.post('/tch/statistics/export', params, {responseType: 'blob'}).
        then((response) => {
          const blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '外管绩效统计.xlsx'
          link.click()
          this.$Message.success('导出成功')
        }).
        catch((error) => {
          this.$Message.error('导出失败：' + error.message)
        }).
        finally(() => {
          this.exportLoading = false
        })
    }
  }
}
</script>

<style scoped>
.list {
  padding: 20px;
}

.breadcrumb {
  margin-bottom: 20px;
}

.search {
  background: #f8f8f9;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
}

.table-container {
  background: white;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.ivu-table-wrapper {
  border: none;
}

.ivu-table th {
  background-color: #f8f8f9;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// TchPerformanceList.vue?b08d7bde